import React, { Component } from 'react'
import { reduxForm } from 'redux-form'

import validate from 'utils/validate'
import { getSellableItem } from 'selectors/grid'

import FIELDS from './fields'
import GridTicketModalForm from './grid-ticket-modal-form'

const FIELD_NAMES = FIELDS.map(field => field.name)

class GridTicketModalFormContainer extends Component {

  render() {
    return <GridTicketModalForm {...this.props} />
  }

}

const mapStateToProps = (state, ownProps) => {
  let initialValues = null
  if (ownProps.currentEditSellableItemId) {
    initialValues = getSellableItem(ownProps.currentEditSellableItemId)(state)
  }

  return {
    initialValues,
  }
}

export default reduxForm({
  form: 'setupformGrid',
  fields: FIELD_NAMES,
  validate: validate(FIELDS),
}, mapStateToProps)(GridTicketModalFormContainer)



/** WEBPACK FOOTER **
 ** ./src/components/grid-ticket-modal/grid-ticket-modal-form/grid-ticket-modal-form-container.js
 **/